/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCrystalWand: {
  name: 'crystal_wand';
  data: string;
} = {
  name: 'crystal_wand',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m595.287 170.19.579-.579-11.254-144.852-145.358-11.756-.578.578-.002-.002v.003L270.521 181.735l.133 1.641-1.643-.133 1.776 1.776 8.779 108.523-39.41-39.409c-5.43 51.058-34.547 78.438-84.735 84.735l22.147 22.146-157.143 156.66v73.997h64.224l161.788-161.789 23.116 23.116c6.521-49.963 33.996-78.986 84.735-84.735l-38.574-38.573 108.148 8.402 1.759 1.759-.127-1.632 1.637.127.002-.003L595.287 170.19zm-176.047 87.5-4.869-62.691-63.436-5.13 94.13-94.132.257.014 5.112 63.185 62.689 4.871-93.883 93.883z"/></svg>`,
};
